import React from 'react';
import '../styles/InfoCard.css'; 
import '../styles/DetalleEntidad.css'; 

const PuertoAlmacenamiento = ({ almacenamiento }) => {
  
  const datosAVisualizar = almacenamiento && almacenamiento.length > 0 ? almacenamiento : [];

  if (datosAVisualizar.length === 0) {
    return (
      <div className="almacenamiento-container">
        <h3>Infraestructura de Almacenamiento</h3>
        <p className="text-muted">No hay información detallada de almacenamiento disponible para este puerto.</p>
      </div>
    );
  }

  return (
    <div className="almacenamiento-container fade-in">
      <h3>Infraestructura de Almacenamiento</h3>
      <p className="text-muted">
        Capacidades, áreas disponibles e imágenes de las instalaciones en el recinto portuario.
      </p>

      <div className="cards-grid-almacen">
        {datosAVisualizar.map((item, index) => (
          <div key={index} className="info-card almacenamiento-card">
            {/* Renderizado condicional de la imagen */}
            {item.imagen ? (
              <div 
                className="almacen-img" 
                style={{ backgroundImage: `url(${item.imagen})` }}
                title={`Imagen de ${item.tipo}`}
              />
            ) : (
              <div className="almacen-icon-header">
                <span className="icon-storage">🏭</span>
              </div>
            )}

            <div className="card-body">
              <h4 className="almacen-title">{item.tipo || "Instalación"}</h4>
              
              <div className="dato-row">
                <strong>Área:</strong>
                <span>{item.area ? (isNaN(item.area) ? item.area : `${item.area} m²`) : 'N/D'}</span>
              </div>
              <div className="dato-row">
                <strong>Capacidad:</strong>
                <span>{item.capacidad || 'N/D'}</span>
              </div>
              <div className="dato-row">
                <strong>Características:</strong>
                <span className="tag-status">{item.caracteristicas || 'Estándar'}</span>
              </div>
              {item.observaciones && (
                <div className="dato-row nota">
                  <small>*{item.observaciones}</small>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>

     
        <style jsx="true">{`
        .cards-grid-almacen {
          display: grid;
          /* Aumenté el ancho mínimo de 280px a 340px para que la tarjeta sea más ancha */
          grid-template-columns: repeat(auto-fill, minmax(540px, 1fr));
          gap: 25px;
          margin-top: 25px;
          justify-content: start; /* Alinea los elementos a la izquierda del grid */
          margin-left: -20px; /* "Empuja" visualmente todo el contenedor a la izquierda */
          width: calc(100% + 20px); /* Compensa el ancho para que no quede corto a la derecha */
        }
        .almacenamiento-card {
          padding: 0 !important;
          overflow: hidden;
          display: flex;
          flex-direction: column;
          background-color: #222;
          border: 1px solid #333;
          border-radius: 8px; 
        }
        .almacen-img {
          width: 100%;
          /* Altura grande para la imagen */
          height: 500px; 
          background-size: cover;
          background-position: center;
          border-bottom: 1px solid #333;
        }
        .almacen-icon-header {
          height: 120px; 
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #2a2a2a;
          font-size: 3.5rem;
          border-bottom: 1px solid #333;
        }
        .card-body {
          padding: 20px; 
          display: flex;
          flex-direction: column;
          gap: 10px;
        }
        .almacen-title {
          margin: 0 0 10px 0;
          color: #E50914;
          font-size: 1.3rem; 
        }
        .dato-row strong {
          color: #aaa;
          margin-right: 6px;
        }
        .tag-status {
          background-color: #333;
          padding: 3px 8px;
          border-radius: 4px;
          font-size: 0.9rem;
          color: #ddd;
        }
        .nota {
          margin-top: 10px;
          border-top: 1px solid #333;
          padding-top: 10px;
          color: #888;
          font-style: italic;
        }
      `}</style>
    </div>
  );
};

export default PuertoAlmacenamiento;